<template>
  <modal :show="showModal" @close="close">
    <div class>
      <div class="modal-header p-0 p-b-10 m-b-30">
        <h5>Role Form</h5>
      </div>
      <validation-observer v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit(submit)">
          <div class="required-info">
            <div class="row">
              <div class="col-md-6">
                <validation-provider
                  name="name"
                  rules="required|max:100"
                  v-slot="{ errors }"
                  tag="div"
                  class="form-group"
                >
                  <label for="name">
                    Role Name:
                    <span class="required">*</span>
                  </label>
                  <div class="input-wrapper">
                    <input
                      type="text"
                      id="name"
                      v-model="model.name"
                      placeholder="Title"
                      :class="{'is-invalid':errors.length}"
                      class="form-control"
                      autocomplete="off"
                    />
                    <div class="invalid-feedback">{{ errors[0] }}</div>
                  </div>
                </validation-provider>
              </div>
              <div class="col-md-6"></div>
            </div>
            <div class="row p-0 m-b-30">
              <div class="col-md-12">
                <validation-provider
                  name="permissions"
                  rules="required"
                  v-slot="{ errors }"
                  tag="div"
                  class="row"
                >
                  <div
                    class="col-sm-4 mb-4"
                    v-for="(item, index) in permissions"
                    :key="item.id"
                    :class="{'is-invalid-checkbox':errors.length}"
                  >
                    <label class="mb-4 font-16">{{item.name}}</label>
                      <div class="checkbox-wrapper">
                          <div class="custom-checkbox" v-for="(sub_item, sub_index) in item.permissions" :key="sub_item.id">
                              <input type="checkbox"
                                     v-model="model.permissions"
                                     :value="sub_item.id"
                                     :id="'permissions_' + item.id + '_' + sub_item.id"
                                     :name="'permissions_' + item.id + '_' + sub_item.id"
                              >
                              <label :for="'permissions_' + item.id + '_' + sub_item.id">{{ sub_item.title }}</label>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-12" v-if="errors.length">
                    <div class="invalid-feedback-message">{{ errors[0] }}</div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="row">
              <!-- End col -->
              <div class="col-md-12" v-if="error_message">
                <div class="global-invalid-feedback">{{ error_message }}</div>
              </div>
              <div class="col-md-12">
                <button type="submit" class="primary-btn mx-auto">{{submit_btn_name}}</button>
              </div>
            </div>
          </div>
        </form>
      </validation-observer>
    </div>
  </modal>
</template>
<script>
const Swal = require("sweetalert2");

export default {
  data() {
    return {
      showModal: false,
      error_message: "",
      get_url: "/dashboard/roles/edit/",
      post_url: "",
      model: {},
      submit_btn_name: "",
      is_submitted: false,
      can_keyword_modify: true,
      permissions: {}
    };
  },
  created() {},
  methods: {
    openModal: function(id) {
      if (id) {
        this.post_url = "/dashboard/roles/edit/" + id;
        this.submit_btn_name = "Update Changes";
      } else {
        this.post_url = "/dashboard/roles/create";
        this.submit_btn_name = "Submit";
      }
      var _this = this;
      axios
        .get(this.get_url + id)
        .then(({ data }) => {
          this.showModal = true;
          this.permissions = data.permissions;
          this.model = data.model;

          if (!this.model.permission_label_id) {
            this.model.permission_label_id = "";
          }
        })
        .catch(function(error) {
          _this.$throwSwalError(error);
        });
    },
    close: function() {
      this.showModal = false;
      this.required = false;
      this.model = {};
      this.$nextTick(() => this.$refs.form.reset());
    },
    submit: function(e) {
      this.is_submitted = true;
      axios
        .post(this.post_url, this.model)
        .then(response => {
          this.close();
          this.$parent.fetchData();
          this.is_submitted = false;
          Swal.fire({
              position: "center",
            icon: "success",
              title: "Action completed!",
            showConfirmButton: false,
            timer: 1500
          });
        })
        .catch(error => {
          this.is_submitted = false;
          if (error.response.status == 422) {
            this.error_message = error.response.data.message;
            this.$refs.form.setErrors(error.response.data.errors);
          } else {
            this.showModal = false;
            this.$throwSwalError(error);
            this.error_message = "Something wrong at form!";
          }
        });
    }
  },
  components: {
    modal: require("./../Modal").default
  }
};
</script>
